import React, { Fragment, useEffect, useState } from "react";
import { Form, Input, Space, Select, Flex } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import "@/styles/pages/auth/forgot-password.scss";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentForm, setToken, getIsLoggedIn, setFormProps } from "@/reducers/commonSlice";
import { forgotPassword } from "@/services/accounts/forgotPassword";
import { countryList } from "@/helpers/countryList";
import { keyFilterOption } from "@/helpers";

// const filterOption = (input, option) =>
//   (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const { Option } = Select;

const ForgotPassword = ({ isOpen = false, email = "", mobileNumber = "" }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const [form] = Form.useForm(); // Assigning the form instance
  const [isEmailSignIn, setIsEmailSignIn] = useState(true);

  useEffect(() => {
    if (!!email) {
      form.setFields([
        {
          name: "email",
          value: email,
        },
      ]);
    }
    if (!!mobileNumber) {
      const mobileData = mobileNumber.split(" ");
      form.setFields([
        {
          name: "countryCode",
          value: mobileData[0],
        },
        {
          name: "mobileNumber",
          value: mobileData[1],
        },
      ]);
    }
  }, [email, mobileNumber]);

  const handleFinish = (value) => {
    console.log(value);
    if (!isEmailSignIn) {
      if (value.countryCode) {
        value.mobileNumber = value.countryCode + " " + value.mobileNumber;
        delete value.countryCode;
      } else {
        value.mobileNumber = "+91" + " " + value.mobileNumber;
        delete value.countryCode;
      }
      delete value.email;
    } else {
      delete value.mobileNumber;
      delete value.countryCode;
    }
    console.log(value);

    forgotPassword({
      ...value,
    })
      .then((response) => {
        console.log(response.totp);
        dispatch(setToken(response.token));
        dispatch(setCurrentForm("forgotPasswordVerifyOTP"));
        dispatch(setFormProps({ value }));
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.msg;
        if (errorMessage) {
          switch (errorMessage) {
            case "User not found":
              form.setFields([
                {
                  name: "email",
                  errors: ["User not found, recheck the email you entered."],
                },
                {
                  name: "mobileNumber",
                  errors: ["User not found, recheck the mobile number you entered."],
                },
              ]);
              break;
            case "Email not verified yet.":
              form.setFields([
                {
                  name: "email",
                  errors: ["Email not verified yet."],
                },
              ]);
              break;
            default:
              form.setFields([
                {
                  name: "email",
                  errors: [errorMessage],
                },
                {
                  name: "mobileNumber",
                  errors: [errorMessage],
                },
              ]);
              break;
          }
        }
      });
  };

  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Sign In"
        isOpen={isOpen}
        width={476}
        className="onboarding-modal"
      >
        <div className="forgot-password-modal">
          <div className="heading title-h5">
            Forgotten your <br /> <span className="title-h5-1">password?</span>
          </div>
          <div className="form">
            <Form
              form={form} // Attach the form instance here
              name="register"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleFinish}
            >
              <div className="toggle-options body-b4-1">
                <span onClick={() => setIsEmailSignIn(!isEmailSignIn)}>
                  {isEmailSignIn ? "Request OTP using Phone Number" : "Request OTP using Use Email"}
                </span>
              </div>

              {isEmailSignIn && (
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      type: "email",
                      required: true,
                      message: "Please enter a valid email address.",
                    },
                  ]}
                >
                  <Input placeholder="Enter your email" disabled={email?.length} />
                </Form.Item>
              )}

              {!isEmailSignIn && (
                <Form.Item label="Phone Number">
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item name={"countryCode"} noStyle>
                      <Select
                        virtual={false}
                        showSearch
                        placeholder="Select Contry"
                        defaultValue={"+91"}
                        filterOption={keyFilterOption}
                        disabled={mobileNumber?.length}
                        style={{
                          maxWidth: "35%",
                        }}
                      >
                        {countryList.map((country) => {
                          return (
                            <Option
                              key={country.name}
                              value={country.phoneCode}
                              label={country.phoneCode}
                            >
                              <Flex justify="start" align="center" gap={"5px"}>
                                <img src={country.flag} height={30} width={30} />{" "}
                                {window.innerWidth > 425 ? <span>{country.phoneCode}</span> : <></>}
                              </Flex>
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="mobileNumber"
                      noStyle
                      rules={[
                        {
                          min: 7,
                          max: 14,
                          required: true,
                          message: "Please provide a valid mobile number with WhatsApp.",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{
                          width: "80%",
                        }}
                        disabled={mobileNumber?.length}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        placeholder="Enter your mobile number"
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>
              )}

              <Form.Item>
                <div className="button">
                  <ButtonComponent label="Send OTP" varient="primary" htmlType="submit" />
                </div>
              </Form.Item>
            </Form>
            {!isLoggedIn ? (
              <div className="signup body-b4-1">
                <span onClick={() => dispatch(setCurrentForm("signIn"))}>Back to Login</span>
              </div>
            ) : null}
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default ForgotPassword;
